import { I18n } from "@assets/strings";
import React from "react";
import { ClipLoader } from "react-spinners";
import styled from "styled-components";
import { ArticleStatus } from "@domain/lms/article/article";
import { useMyArticles } from "@domain/lms/article/hooks";
import { ArticleThumbnail } from "@ui/components/article/articleThumbnail";
import { Secondary } from "@ui/components/containers/textBlocks";
import { InfiniteScroll } from "@ui/components/infiniteScroll";
import { desktop, gap, mobile } from "@ui/styles/utils";

interface MyArticlesListProps extends React.HTMLAttributes<HTMLDivElement> {
	status: ArticleStatus | "ALL";
}

export const MyArticlesList: React.FC<MyArticlesListProps> = ({ status, ...htmlProps }) => {
	const { result: articles, fetchMore, loading, moreLoading, totalElements } = useMyArticles(status);

	return (
		<Container>
			{totalElements === 0 ? (
				<Secondary>
					{I18n.t(status === "ALL" ? "profile.article_self.empty_all" : "profile.article_self.empty")}
				</Secondary>
			) : (
				<InfiniteScroll onEndReached={fetchMore} loading={loading || moreLoading}>
					<Articles {...htmlProps}>
						{articles.map((article) =>
							article ? (
								<ArticleThumbnail key={article.id} article={article} displayStatus displayAuthorAsMe />
							) : undefined
						)}
						{loading && <ClipLoader />}
					</Articles>
				</InfiniteScroll>
			)}
		</Container>
	);
};

const Container = styled.div`
	display: flex;
	flex-direction: column;
`;

const Articles = styled.div`
	@media ${desktop} {
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		grid-gap: 20px;
	}
	@media ${mobile} {
		${gap(20)};
	}
`;
